import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { P } from '@piconetworks/text'
import Avatar from '@piconetworks/avatar'
import style from './LoginHeader.module.scss'

const LoginHeader = ({
    memberType,
    textColor,
    linkColor,
    contrastColor,
    userInitials,
    userEmail,
    isLoggedIn,
    onLoginButtonClick = () => { },
    hideLogin = false,
    useDefault = false,
    welcomeBack = false,
}) => {
    const defaultText = welcomeBack ? 'Don\'t have an account yet?' : 'Already have an account ? '
    const promptText = memberType && !useDefault ? `Already a ${memberType}?` : defaultText

    if (isLoggedIn) {
        return (
            <div
                className={classNames(style.headerButton, { [style.noHover]: !!isLoggedIn })}
            >
                <Avatar
                    initials={userInitials}
                    linkColor={linkColor}
                    size="24px"
                    contrastColor={contrastColor}
                    style={{ marginRight: '8px' }}
                />
                <span>
                    {'Logged in as '}
                    <span className={style.email}>{userEmail}</span>
                </span>
            </div>
        )
    }

    if (hideLogin) {
        return null
    }

    return (
        <>
            <P
                className={style.headerDescription}
                style={{ color: textColor }}
            >
                {promptText}
            </P>
            <button
                onClick={onLoginButtonClick}
                className={classNames(style.headerButton, style.login)}
                type="button"
            >
                {welcomeBack ? 'Sign up' : 'Log in'}
            </button>
        </>
    )
}

LoginHeader.defaultProps = {
    linkColor: '',
    contrastColor: '',
    memberType: '',
    textColor: '',
    userInitials: '',
    userEmail: '',
    isLoggedIn: false,
    onLoginButtonClick: () => { },
    hideLogin: false,
    useDefault: false,
    welcomeBack: false,
}

LoginHeader.propTypes = {
    linkColor: PropTypes.string,
    contrastColor: PropTypes.string,
    memberType: PropTypes.string,
    textColor: PropTypes.string,
    userInitials: PropTypes.string,
    userEmail: PropTypes.string,
    isLoggedIn: PropTypes.bool,
    onLoginButtonClick: PropTypes.func,
    hideLogin: PropTypes.bool,
    useDefault: PropTypes.any,
    welcomeBack: PropTypes.bool,
}

export default React.memo(LoginHeader)
